export default [
    {title: "RechargeBalances.RechargeStatus.Accepted", value: "1"},
    {title: "RechargeBalances.RechargeStatus.NotAccepted", value: "2"}
]
